document.addEventListener('DOMContentLoaded', function() {
  const quickviewModal = document.getElementById('quickview-modal');
  const quickviewClose = document.querySelector('.quickview-close');
  const quickviewContainer = document.querySelector('.quickview-container');
  
  // Default translations - can be overridden by window.quickviewTranslations
  const defaultTranslations = {
    loading: 'Učitava...',
    add_to_cart: 'Dodaj u korpu',
    buy_now: 'Kupi odmah',
    sold_out: 'Rasprodano',
    unavailable: 'Nedostupno',
    out_of_stock: 'Nema na stanju',
    view_product: 'Pogledaj sve detalje',
    size: 'Veličina',
    color: 'Boja',
    error_loading: 'Greška pri učitavanju proizvoda. Pokušajte ponovo.',
    close: 'Zatvori'
  };
  
  function getTranslation(key) {
    return (window.quickviewTranslations && window.quickviewTranslations[key]) || defaultTranslations[key] || key;
  }
  
  // HTML entity decoder utility
  function decodeHTMLEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }
  
  // Safe JSON parser with error handling and HTML decoding
  function safeJSONParse(jsonString) {
    if (!jsonString) return null;
    
    try {
      // First, try to parse as-is
      return JSON.parse(jsonString);
    } catch (e) {
      
      try {
        // Use the browser's built-in HTML entity decoder
        const decodedJson = decodeHTMLEntities(jsonString);
        return JSON.parse(decodedJson);
      } catch (e2) {
        
        try {
          // Manual HTML decode as fallback
          let cleanedJson = jsonString
            // Decode common HTML entities
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&#x27;/g, "'")
            .replace(/&#x2F;/g, '/')
            .replace(/&#39;/g, "'")
            // Remove any trailing commas
            .replace(/,(\s*[}\]])/g, '$1')
            // Remove control characters that might break JSON
            .replace(/[\x00-\x1f\x7f-\x9f]/g, '')
            // Fix common malformed JSON patterns
            .replace(/,(\s*$)/gm, '') // trailing commas at end of lines
            .replace(/"\s*:\s*"([^"]*?)\s*=\s*([^"]*?)"/g, '": "$1=$2"') // fix malformed attribute patterns
            // Fix incomplete strings (this is a basic attempt)
            .replace(/"\s*$(?!\s*[,}\]])/gm, '""'); // close unclosed quotes at end of lines
          
          return JSON.parse(cleanedJson);
        } catch (e3) {
          return null;
        }
      }
    }
  }
  
  // Image preloader function
  function preloadImage(src) {
    return new Promise((resolve, reject) => {
      if (!src) {
        resolve(null);
        return;
      }
      
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
      img.src = src;
    });
  }
  
  // Preload multiple images (for variants)
  function preloadImages(imageSources) {
    const uniqueSources = [...new Set(imageSources.filter(src => src))];
    return Promise.allSettled(uniqueSources.map(preloadImage));
  }
  
  function openQuickview(productHandle) {
    if (!productHandle) return;
    
    quickviewContainer.innerHTML = `
      <div class="quickview-loading"></div>
    `;
    
    // Show modal immediately with loading state
    quickviewModal.style.display = 'flex';
    setTimeout(() => {
      quickviewModal.classList.add('active');
    }, 10);
    
    document.body.style.overflow = 'hidden';
    
    loadProductData(productHandle);
  }
  
  function closeQuickview() {
    if (!quickviewModal.classList.contains('active')) return;
    
    quickviewModal.style.display = 'none';
    quickviewModal.classList.remove('active');
    
    setTimeout(() => {
      if (quickviewModal) {
        quickviewModal.style.display = 'none';
        quickviewContainer.innerHTML = '';
      }
    }, 300);
    
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
  
  quickviewModal.addEventListener('click', function(e) {
    if (e.target === quickviewModal) {
      closeQuickview();
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && quickviewModal.classList.contains('active')) {
      closeQuickview();
    }
  });
  
  if (quickviewClose) {
    quickviewClose.addEventListener('click', closeQuickview);
  }
  
  // NIA-7364: product data is no longer inlined on every grid item. It is
  // fetched on demand from /products/<handle>?view=quickview (a layout-less
  // template that outputs the same JSON) and cached per handle.
  const quickviewCache = {};

  function fetchQuickviewData(handle) {
    if (!handle) return Promise.resolve(null);
    if (quickviewCache[handle]) return Promise.resolve(quickviewCache[handle]);
    return fetch(`/products/${handle}?view=quickview`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(text => {
        const productData = safeJSONParse(text);
        if (productData) quickviewCache[handle] = productData;
        return productData;
      });
  }

  function loadProductData(handle) {
    fetchQuickviewData(handle)
      .then(productData => {
        if (!productData) {
          throw new Error('Invalid quickview data');
        }
        // Collect all image sources for preloading
        const imageSources = [];
        if (productData.featured_image) {
          imageSources.push(productData.featured_image);
        }
        if (productData.variants) {
          productData.variants.forEach(variant => {
            if (variant.featured_image && variant.featured_image.src) {
              imageSources.push(variant.featured_image.src);
            }
          });
        }

        // Preload images before rendering
        preloadImages(imageSources).finally(() => {
          renderQuickview(productData);
        });
      })
      .catch(error => {
        quickviewContainer.innerHTML = `
          <div class="quickview-error">
            <p>${getTranslation('error_loading')}</p>
            <p style="font-size: 0.875rem; opacity: 0.7;">Error: ${error.message}</p>
            <button class="button" onclick="closeQuickview()">${getTranslation('close')}</button>
          </div>
        `;
      });
  }
  
  function renderQuickview(product) {
    const locale = Shopify && Shopify.locale ? Shopify.locale : 'en';
    const productUrl = `${locale == 'en' ? '' : `/${locale}`}/products/${product.handle}`;
    const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
    
    let html = `
      <div class="quickview-images">
        <a href="${productUrl}" class="quickview-image-link">
          <div class="quickview-main-image">
            <img id="quickview-featured-image" src="${product.featured_image || ''}" alt="${product.title}" loading="eager" fetchpriority="high" />
          </div>
        </a>
      </div>
      <div class="quickview-details">
        <h2 class="quickview-title">
          <a href="${productUrl}" class="quickview-title-link">${product.title || ''}</a>
        </h2>
        <div class="quickview-price-wrapper">
          <span class="compare-at-price quickview-price" id="quickview-compare-price" style="display: none;"></span>
          <span class="quickview-price" id="quickview-price">${product.price || ''}</span>
        </div>
        
        <div class="quickview-variants">
          ${renderVariantOptions(product)}
        </div>
        
        <div class="quickview-form">
          <form method="post" action="${cartAddUrl}" id="quickview-product-form" class="product-form">
            <input type="hidden" name="id" id="quickview-variant-id" value="">
          
            <button type="submit" name="add" class="button button--primary quickview-add-to-cart" id="quickview-add-to-cart">
              <span>${getTranslation('add_to_cart')}</span>
            </button>

            <button type="button" class="button button--secondary quickview-buy-now" id="quickview-buy-now">
              <span>${getTranslation('buy_now')}</span>
            </button>
          </form>
        </div>
        
        ${product.description ? `<div class="quickview-description">${product.description}</div>` : ''}
        <a href="${productUrl}" class="quickview-view-details">${getTranslation('view_product')}</a>
      </div>
    `;
    
    quickviewContainer.innerHTML = html;
    
    initVariantSelection(product);
    
    const addToCartBtn = document.querySelector('#quickview-add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => {
        setTimeout(closeQuickview, 300);
      });
    }

    const buyNowButton = document.querySelector('#quickview-buy-now')

    if(buyNowButton) {
      buyNowButton.addEventListener('click', (e) => {
        e.preventDefault();

        const variantId = document.getElementById('quickview-variant-id').value ?? null;
        const quantity = 1;

        if (!variantId || buyNowButton.disabled) {
          return;
        }

        window.location.href = `/cart/${variantId}:${quantity}?checkout`;
      })
    }
  }

  function isVariantAvailableForPurchase(variant) {
    if (!variant || variant.available === false) return false;

    const inventoryQuantity = variant.inventory_quantity;
    if (inventoryQuantity === null || inventoryQuantity === undefined || inventoryQuantity === '') return false;

    const numericInventoryQuantity = Number(inventoryQuantity);
    return Number.isFinite(numericInventoryQuantity) && numericInventoryQuantity > 0;
  }
  
  function renderVariantOptions(product) {
    if (!product.options || product.options.length === 0) return '';
    
    let html = '';
    
    product.options.forEach((option, index) => {
      const optionName = option.name.replace('option', '');
      const isColor = optionName.toLowerCase().includes('boja') || optionName.toLowerCase().includes('color');
      const isSize = optionName.toLowerCase().includes('veličina') || optionName.toLowerCase().includes('size');
      
      const displayName = isSize ? getTranslation('size') : (isColor ? getTranslation('color') : optionName);
      
      html += `
        <div class="product-form__input product-form__input--${isColor ? 'swatch' : 'dropdown'}">
          <label class="form__label" for="Option-quickview-${index}">
            ${displayName}: 
            <span class="value-selected" id="value-selected-${index}"></span>
          </label>
          <div class="input-selector-wrapper">
      `;
      
      option.values.forEach((value, valueIndex) => {
        const inputId = `quickview-option-${index}-${valueIndex}`;
        
        let colorValue = null;
        if (isColor && product.variants) {
          const variant = product.variants.find(v => v.options && v.options[index] === value.value);
          if (variant && variant.color) {
            colorValue = variant.color;
          }
        }
        
        html += `
          <div class="input-selector ${isColor ? 'color' : ''} ${isSize ? 'size' : ''}">
            <input type="radio" 
                  id="${inputId}" 
                  name="option-${index}" 
                  value="${value.value}" 
                  data-text="${value.text}"
                  ${valueIndex === 0 ? 'checked' : ''}
                  class="visually-hidden">
            <label for="${inputId}" class="product-variant-label ${colorValue ? 'has-color' : 'no-color'}" ${colorValue ? `style="background-color: ${colorValue};"` : ''}>
              ${isColor && !colorValue ? value.text : (isColor ? '' : value.text)}
            </label>
          </div>
        `;
      });
      
      html += `
          </div>
        </div>
      `;
    });
    
    return html;
  }
  
  function initVariantSelection(product) {
    if (!product.variants || product.variants.length === 0) return;
    
    const variantRadios = document.querySelectorAll('.input-selector input[type="radio"]');
    const variantIdInput = document.getElementById('quickview-variant-id');
    const addToCartBtn = document.getElementById('quickview-add-to-cart');
    const priceElement = document.getElementById('quickview-price');
    
    variantRadios.forEach(radio => {
      radio.addEventListener('change', updateVariantSelection);
    });
    
    function updateVariantSelection() {
      const selectedValues = [];
      
      document.querySelectorAll('.quickview-container .input-selector-wrapper').forEach((wrapper, index) => {
        const selectedRadio = wrapper.querySelector('input[type="radio"]:checked');
        const valueSelectedSpan = document.getElementById(`value-selected-${index}`);
        
        if (selectedRadio && valueSelectedSpan) {
          selectedValues.push(selectedRadio.value);
          valueSelectedSpan.textContent = selectedRadio.dataset.text || selectedRadio.value;
        }
      });
      
      const selectedVariant = product.variants.find(variant => {
        return variant.options && variant.options.every((option, index) => {
          return option === selectedValues[index];
        });
      });

      const buyNowButton = document.querySelector('#quickview-buy-now');
      
      if (selectedVariant) {
        const isVariantAvailable = isVariantAvailableForPurchase(selectedVariant);

        if (variantIdInput) {
          variantIdInput.value = selectedVariant.id;
          variantIdInput.disabled = !isVariantAvailable;
        }
        
        if (priceElement) {
          if (selectedVariant.price) {
            priceElement.textContent = window.formatMoney ? window.formatMoney(selectedVariant.price) : selectedVariant.price;
          }
          
          const comparePriceElement = document.getElementById('quickview-compare-price');
          if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
            comparePriceElement.textContent = window.formatMoney ? window.formatMoney(selectedVariant.compare_at_price) : selectedVariant.compare_at_price;
            comparePriceElement.style.display = 'inline';
            comparePriceElement.style.textDecoration = 'line-through';
            comparePriceElement.style.opacity = '0.7';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }
        
        // Handle variant image switching
        if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
          updateQuickviewImages(selectedVariant.featured_image, product.media);
        }
        
        if (addToCartBtn) {
          if (isVariantAvailable) {
            addToCartBtn.disabled = false;
            addToCartBtn.querySelector('span').textContent = getTranslation('add_to_cart');
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.querySelector('span').textContent = getTranslation('sold_out');
          }
        }

        if (buyNowButton) {
          if (isVariantAvailable) {
            buyNowButton.style.display = 'block';
            buyNowButton.disabled = false;
            buyNowButton.querySelector('span').textContent = getTranslation('buy_now');
          } else {
            buyNowButton.style.display = 'none';
            buyNowButton.disabled = true;
            buyNowButton.querySelector('span').textContent = getTranslation('sold_out');
          }
        }
      } else {
        if (variantIdInput) {
          variantIdInput.value = '';
          variantIdInput.disabled = true;
        }
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.querySelector('span').textContent = getTranslation('unavailable');
        }
        if (buyNowButton) {
          buyNowButton.style.display = 'none';
          buyNowButton.disabled = true;
          buyNowButton.querySelector('span').textContent = getTranslation('unavailable');
        }
      }
    }
    
    updateVariantSelection();
  }

  // New function to update quickview images when variant changes
  function updateQuickviewImages(variantImage, allMedia) {
    if (!variantImage || !variantImage.src) return;
    
    // Update main featured image
    const featuredImage = document.getElementById('quickview-featured-image');
    if (featuredImage) {
      featuredImage.src = variantImage.src;
      featuredImage.srcset = `${variantImage.src} 1x, ${variantImage.src} 2x`;
    }
  }

  // Advanced preloading: Preload images when user hovers over product cards
  function initHoverPreloading() {
    const productCards = document.querySelectorAll('.product-grid-item[data-product-handle]');
    
    productCards.forEach(card => {
      let preloadTimeout;
      
      card.addEventListener('mouseenter', () => {
        // Delay preloading slightly to avoid preloading on quick mouse passes
        preloadTimeout = setTimeout(() => {
          const handle = card.dataset.productHandle;
          if (!handle) return;
          // Prefetch + cache the quickview data so the modal opens instantly,
          // then warm the image cache in the background.
          fetchQuickviewData(handle).then(productData => {
            if (!productData) return;
            const imageSources = [];
            if (productData.featured_image) {
              imageSources.push(productData.featured_image);
            }
            if (productData.variants) {
              productData.variants.forEach(variant => {
                if (variant.featured_image && variant.featured_image.src) {
                  imageSources.push(variant.featured_image.src);
                }
              });
            }
            preloadImages(imageSources).catch(() => {
              // Silently handle preload failures
            });
          }).catch(() => {
            // Silently handle prefetch failures
          });
        }, 150);
      });
      
      card.addEventListener('mouseleave', () => {
        if (preloadTimeout) {
          clearTimeout(preloadTimeout);
        }
      });
    });
  }
  
  setTimeout(initHoverPreloading, 1000);

  window.openQuickview = function(productHandle) {
    openQuickview(productHandle);
  };
  
  window.closeQuickview = closeQuickview;
});
